import { isEmpty } from 'lodash';
import { Modal } from 'antd';
import { AlertIcon } from 'src/icons';
import { Button } from 'src/components';
import { useDispatch } from 'react-redux';
import { convertAppointmentToAuraEncounterAction } from 'src/store/actions/appointment.action';
import { useState } from 'react';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const ConvertAppointmentToAuraEncounterModal = ({
  showConvertAppointmentToAuraModal,
  selectedAppointmentForAuraEncounter,
  hideConvertAppointmentToAuraModal,
  isfilterOn,
  startIndex,
  filterValue,
}) => {
  const dispatch = useDispatch();
  const { user } = useAuth();

  const [submitLoading, setSubmitLoading] = useState(false);

  if (
    !showConvertAppointmentToAuraModal ||
    isEmpty(selectedAppointmentForAuraEncounter)
  ) {
    return null;
  }

  const { record } = selectedAppointmentForAuraEncounter;

  const handleConvertAppointmentToSelectedUser = () => {
    setSubmitLoading(true);
    analytics.track('Converted Appointment to Aura Only', {
      appointment_date: record?.appointmentDateTime?.date,
      appointment_status: 'Not Started',
      practitioner_name: record.practitioner_Name,
      email: user?.email,
    });
    dispatch(
      convertAppointmentToAuraEncounterAction(
        record?.appt_uuid,
        hideConvertAppointmentToAuraModal,
        isfilterOn,
        startIndex,
        setSubmitLoading,
        filterValue
      )
    );
  };

  return (
    <Modal
      open={showConvertAppointmentToAuraModal}
      onCancel={hideConvertAppointmentToAuraModal}
      footer={null}
      width="30vw"
      className="text-xs"
      submitLoading={submitLoading}
    >
      <div className="flex">
        <AlertIcon />
        <span className="mx-4 font-semibold text-lg">Confirmation</span>
      </div>

      <div className="content my-8">
        <p>
          Are you sure you want to convert the appointment to Aura Encounter?
        </p>
        <p className="my-4">
          <div>
            Practitioner Name: <strong>{record.practitioner_Name}</strong>
          </div>
          <div>
            Patient Name: <strong>{record.patient_Name}</strong>
          </div>
        </p>
        <p>This action can not be undone.</p>
      </div>

      <div className="footer flex items-center">
        <Button
          type="button"
          onClick={handleConvertAppointmentToSelectedUser}
          className="px-4 py-2 bg-[#d63232] hover:bg-[#a30000] rounded-md"
        >
          Proceed
        </Button>
        <Button
          type="button"
          onClick={hideConvertAppointmentToAuraModal}
          className="px-4 py-2 bg-[#00D090] hover:bg-[#059669] rounded-md mx-2"
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default ConvertAppointmentToAuraEncounterModal;
